(function(){
    angular
        .module('appback')
        .directive('ngPcrleishgenr', pcrleishgenr);

        pcrleishgenr.$inject = ['$timeout','GenerallabService','ResultadosService'];
        function pcrleishgenr($timeout,GenerallabService,ResultadosService){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=pcrleishgenr.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  categoria: '=',
                  peticion: '=',
                  //sub: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        scope.generalLab = GenerallabService;
		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : {  }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { }};
				            }else{
				            	if(!scope.item.resultado.extra.resultado){
				            		scope.item.resultado.extra.resultado = { };
					            }else{
					            	if(Array.isArray(scope.item.resultado.extra.resultado)){
				            			scope.item.resultado.extra.resultado = { };
					            	}
					            }
				            }
				        }
			        });
		        }
          }
      }
})();